<template>
	<!-- 员工离职 -->
	<div>
		<div v-show="!showAdd && !showEdit">
			<div style="font-size:20px;float:left;margin:-40px 0 0 40px;font-weight:600">员工离职</div>
			<!-- 主体 -->
			<div style="height:750px;background-color:white;margin:75px 40px 0 40px">
				<!-- 查询框 -->
				<div style="margin-left:3%">
					<div style="height:10px"></div>
					<div style="display:inline-block">
						<span>组织架构</span>
						<el-cascader v-model="condition.organize_ids" clearable
							style="margin-left:10px;width:300px" collapse-tags :props="props"></el-cascader>
					</div>

					<!-- <div style="display:inline-block;margin-left:20px">
						<span>城市 </span>
						<el-select v-model="condition.city_id" style="margin-left:10px;width:80%"
							:placeholder="postPlaceholder" clearable>
							<el-option v-for="item in $globals.cityList" :key="item.city" :label="item.city"
								:value="item.city">
							</el-option>
						</el-select>
					</div> -->

					<div style="display:inline-block;margin-top:20px;margin-left:20px">
						<span>岗位 </span>
						<el-select v-model="condition.post_id" style="margin-left:10px;width:150px" placeholder="请选择"
							clearable>
							<el-option v-for="item in postList" :key="item.id" :label="item.post_name" :value="item.id">
							</el-option>
						</el-select>
					</div>

					<div style="display:inline-block;margin-top:20px">
						<span>姓名 </span>
						<el-input v-model="condition.staff_name" style="margin-left:10px;width:150px"
							placeholder="请输入姓名">
						</el-input>
					</div>

					<div style="display:inline-block;margin-top:20px">
						<span>离职日期 </span>
						<el-date-picker style="width:75%" v-model="condition.quit_date" type="daterange"
							range-separator="至" start-placeholder="开始日期" format="yyyy-MM-dd" end-placeholder="结束日期"
							value-format="yyyy-MM-dd">
						</el-date-picker>
					</div>

					<div style="display:inline-block;margin-top:20px;margin-left:20px">
						<span>状态 </span>
						<el-select v-model="condition.state" style="margin-left:10px;width:150px" placeholder="请选择"
							clearable>
							<el-option v-for="item in ztList" :key="item.value" :label="item.label" :value="item.value">
							</el-option>
						</el-select>
					</div>

					<!-- 按钮 -->
					<div style="display:inline-block;margin-left:50px">
						<el-button type="goon" @click="find">查询</el-button>
						<el-button type="goon" @click="del(null)">删除</el-button>
						<el-button type="addbtn" @click="add">新增</el-button>
					</div>
					<div style="display:inline-block;margin-left:220px">
						<download-excel class="export-excel-wrapper" :fields="download_excel" title="离职人员清单"
									name="离职人员清单.xls" :fetch="ExportForm"
									style="margin-left:-180px;top:100px">
							<el-button type="goon" style="width: 85px; background-color: #006E4B; color: #FFFFFF; border: 1px solid #006E4B;">
								导表</el-button>
						</download-excel>
					</div>
				</div>

				<!-- 表格 -->
				<div style="margin:1% 3% 0 3%">
					<el-table :header-cell-style="{background:'#F0F0F0',color:'#000000'}"
						:row-class-name="tableRowClassName" ref="multipleTable" :data="tableData" tooltip-effect="dark"
						style="width: 100%;" height="540" @selection-change="handleSelectionChange">
						<el-table-column type="selection" width="55">
						</el-table-column>
						<el-table-column align="center" label="序号" width="50">
							<template slot-scope="scope_1">{{scope_1.$index + 1}}</template>
						</el-table-column>
						<el-table-column align="center" label="组织架构" width="300">
							<template slot-scope="scope">
								{{$globals.group_name + "/" + scope.row.staff.range}}
							</template>
						</el-table-column>
						<!-- <el-table-column prop="staff.city_id" align="center" label="城市"></el-table-column> -->
						<el-table-column prop="staff.post_name" align="center" label="职位"></el-table-column>
						<el-table-column prop="staff.staff_name" align="center" label="姓名"></el-table-column>
						<el-table-column prop="staff.staff_card" align="center" label="身份证号码" width="120">
						</el-table-column>
						<el-table-column prop="staff.induction_time" align="center" label="入职日期" width="120">
						</el-table-column>
						<el-table-column prop="staff.staff_telephone" align="center" label="手机号码"></el-table-column>
						<el-table-column prop="quit_date" align="center" label="离职日期"></el-table-column>
						<el-table-column prop="dictionaries_data" align="center" label="离职原因"></el-table-column>
						<el-table-column prop="" align="center" label="状态" width=100>
							<template slot-scope="scope">
								<img src="../../../assets/待审批.png" v-show="scope.row.state === '0'" />
								<img src="../../../assets/已同意.png" v-show="scope.row.state === '1'" />
								<img src="../../../assets/stateImg/状态_已驳回.png" v-show="scope.row.state === '2'" />
							</template>
						</el-table-column>
						<el-table-column align="center" label="操作" width="150" fixed="right">
							<template slot-scope="scope">
								<img src="../../../assets/详情.png" @click="edit(scope.row)">
								<img src="../../../assets/编辑.png" @click="modify(scope.row)">
								<img src="../../../assets/删除.png" @click="del(scope.row.id)">
							</template>
						</el-table-column>
					</el-table>

					<!-- 分页 -->
					<el-row style="margin-top: 10px; text-align: center;">
						<el-pagination background @current-change="handleCurrentChange" :page-size="page_size"
							layout=" prev, pager, next, jumper" :total="total">
						</el-pagination>
					</el-row>
				</div>

			</div>
		</div>
		<add ref="add" v-show="showAdd" :ruleForm="ruleForm" :organizeList="organizeList" :causeList="causeList"
			:userList="userList" @return="Return()"></add>
		<edit ref="edit" v-show="showEdit" :ruleForm="ruleForm" @return="Return()"></edit>
	</div>
</template>

<script>
	import add from './Yglz_add.vue';
	import edit from './Yglz_edit.vue';
	export default {
		components: {
			add: add,
			edit: edit,
		},
		data() {
			var organizeFind = async (e, spare8) => {
				var organizeList = await this.$globals.AxiosPost("organize/findHierarchy", {
					identification: "1",
					organize_id: e,
					spare8: spare8,
				});
				return organizeList.data;
			};
			return {
				//列表相关
				page_num: 1,
				page_size: 10,
				total: 0,
				tableData: [],

				// 条件
				condition: {
					organize_ids: [],
					city_id: '',
					post_id: '',
					staff_name: '',
					quit_date: '',
					state: '',
				},

				//详情
				ruleForm: {
					id: '',
					staff_id: '',
					dictionaries_id: '',
					quit_date: '',
					quit_url: '',
					quit_time: '',
					operator: '',
					remarks: '',
					applicant_id: '',
					staff: {},
					examineDetailsList: [],
					induction_salary:'',
				},

				download_excel: {
				    "组织架构": "ranges",
				    "姓名": "staff_name",
					"性别":"staff_gender",
				    "职位": "post_name",
					"身份证号": {
						field: "staff_card",
						callback: value => {
							return "&nbsp;" + value;
						}
					},
				    "手机号": "staff_telephone",
				    "入职时间": "induction_time",
					"离职日期": "quit_date",
					
					"离职原因": "dictionaries_data",
					"现薪资":"spare6",
					"备注": "remarks",
				},


				// 页面相关
				showAdd: false,
				showEdit: false,

				// 删除ids
				ids: [],

				//职位数据
				postList: [],
				//离职原因
				causeList: [],
				//操作人数据
				userList: [],

				//状态数据
				ztList: [{
						value: '0',
						label: '待审批',
					},
					{
						value: '1',
						label: '已同意',
					},
					{
						value: '2',
						label: '已驳回',
					},
				],

				//组织架构数据
				organizeList: [],

				//级联下拉配置
				props: {
					lazy: true,
					async lazyLoad(node, resolve) {
						if (node.level === 0) {
							return resolve(await organizeFind('', 'group'));
						} else {
							resolve(await organizeFind(node.data.id, ''));
						}
					},
					value: "id",
					label: "organize_name",
					children: "organizeList",
					checkStrictly: true,
					multiple: true,
				},

			};
		},
		methods: {
			// 全选
			handleSelectionChange(e) {
				this.ids = [];
				e.forEach((item) => {
					this.ids.push(item.id);
				});
			},
			//分页
			handleCurrentChange(val) {
				this.page_num = val;
				this.find();
			},
			//查询
			async find() {
				var temporary = [];
				this.condition.organize_ids.forEach(item => {
					temporary.push(item[item.length - 1]);
				})
				var organize_ids = "";
				temporary.forEach(item => {
					organize_ids += item + ",";
				})

				var url = '/StaffQuit/SelectAll';
				var record = {
					page_num: this.page_num,
					page_size: this.page_size,
					organize_ids: organize_ids,
					staff_name: this.condition.staff_name,
					city_id: this.condition.city_id,
					state: this.condition.state,
					post_id: this.condition.post_id,
					start_date: this.condition.quit_date != null && this.condition.quit_date != '' ?
						this.condition.quit_date[0] : '',
					end_date: this.condition.quit_date != null && this.condition.quit_date != '' ?
						this.condition.quit_date[1] : '',
					applicant_id:this.$globals.user.staff_id,
				};
				var data = await this.$globals.AxiosPost(url, record);
				if (data === '-2000') {
					this.$message.error('服务器未响应！请稍后重试');
				} else {
					var code = data.code;
					var data = data.data;
					if (code === '200') {
						this.tableData = data.list;
						this.total = data.total;
					} else {
						this.$message.warning('请求失败！请稍后重试');
					}
				}
			},

			// 导表
			async ExportForm(){
				var temporary = [];
				this.condition.organize_ids.forEach(item => {
					temporary.push(item[item.length - 1]);
				})
				var organize_ids = "";
				temporary.forEach(item => {
					organize_ids += item + ",";
				})

				var url = '/StaffQuit/SelectQuitAlls';
				var record = {
					organize_ids: organize_ids,
					staff_name: this.condition.staff_name,
					city_id: this.condition.city_id,
					state: this.condition.state,
					post_id: this.condition.post_id,
					start_date: this.condition.quit_date != null && this.condition.quit_date != '' ?
						this.condition.quit_date[0] : '',
					end_date: this.condition.quit_date != null && this.condition.quit_date != '' ?
						this.condition.quit_date[1] : '',
					applicant_id:this.$globals.user.staff_id,
				};
				var data = await this.$globals.AxiosPost(url, record);
				if (data === '-2000') {
					this.$message.error('服务器未响应！请稍后重试');
				} else {
					var code = data.code;
					var data = data.data;
					if (code === '200') {
						if(data.length > 0){
							this.$message.success("导表成功！文件下载中！");
							return data;
						}else{
							this.$message.success("没有可以导出的数据！");
							return null;
						}
						
					} else {
						this.$message.warning(data);
					}
				}
			},



			// 操作删除
			async del(e) {
				var ids;
				if (e === null || e === '' || e === undefined) {
					if (this.ids === null || this.ids.length <= 0) {
						this.$message.warning('请先选择操作数据！');
						return false;
					}
					ids = this.ids;
				} else {
					ids = [e];
				}

				var url = '/StaffQuit/del';
				var record = {
					ids: ids,
				};
				var data = await this.$globals.AxiosPost(url, record);
				if (data === '-2000') {
					this.$message.error('服务器未响应！请稍后重试');
				} else {
					var code = data.code;
					var data = data.data;
					if (code === '200') {
						this.$message.success(data);
						this.trash();
						this.find();
					} else {
						this.$message.warning(data);
					}
				}
			},
			// 新增
			add() {
				this.trash();
				this.ruleForm.quit_time = this.$globals.getNowTime();
				this.ruleForm.operator = this.$globals.user.id;
				this.ruleForm.applicant_id = this.$globals.user.staff_id;
				this.showAdd = true;
			},
			// 修改
			modify(e) {
				this.trash();
				this.ruleForm = e;
				// this.ruleForm.operator = parseInt(e.operator);
				this.showAdd = true;
			},
			// 操作详情
			edit(e) {
				this.ruleForm = e;
				this.showEdit = true;
			},
			//清除数据
			trash() {
				this.ruleForm = {
					id: null ,
					staff_id: '',
					dictionaries_id: '',
					quit_date: '',
					quit_url: '',
					quit_time: '',
					operator: '',
					remarks: '',
					applicant_id: '',
					staff: {},
					examineDetailsList: [],
				}
				
			},
			// 返回
			Return() {
				this.showAdd = false;
				this.showEdit = false;
				this.trash();
				this.Find();
			},
			//初始化组织架构及下面的人
			async organizeFind() {
				var organizeList = await this.$globals.AxiosPost("organize/selectOrganizeStaff", {
					identification: "1",
				});
				this.organizeList = this.getTreeData(organizeList.data);

			},
			getTreeData(data) {
				// 循环遍历json数据
				for (var i = 0; i < data.length; i++) {

					if (data[i].organizeList.length < 1) {
						// children若为空数组，则将children设为undefined
						data[i].organizeList = undefined;
					} else {
						// children若不为空数组，则继续 递归调用 本方法
						this.getTreeData(data[i].organizeList);
					}
				}
				return data;
			}
		},
		async created() {
			// this.find();
			this.organizeFind();
			// 职位数据
			var postList = await this.$globals.AxiosPost('post/selectFind', {});
			this.postList = postList.data;
			// 离职原因数据
			var causeList = await this.$globals.AxiosPost('dictionaries/selectFind', {
				data_grouping: 'resignation_reason'
			});
			this.causeList = causeList.data;
			// 操作人数据
			var userList = await this.$globals.AxiosPost("user/selectFind", {});
			this.userList = userList.data;
		},
	};
</script>

<style>
	.el-button--goon:focus,
	.el-button--goon:hover {
		background: #006e4b;
		border-color: #05573d;
		color: #fff;
	}

	.el-button--addbtn:focus,
	.el-button--addbtn:hover {
		background: #fff;
		border-color: #05573d;
		color: #006e4b;
	}

	.el-button--goon {
		color: #fff;
		background-color: #006e4b;
		border-color: #006e4b;
		font-size: 15px;
		width: 85px;
	}

	.el-button--addbtn {
		color: #006e4b;
		background-color: #fff;
		border-color: #006e4b;
		font-size: 15px;
		width: 85px;
	}

	.el-table .warning-row {
		background: oldlace;
	}

	.el-table .success-row {
		background: #f0f9eb;
	}

	.el-checkbox__input.is-checked .el-checkbox__inner {
		background-color: #006e4b;
		border-color: #006e4b;
	}

	.el-checkbox__input.is-focus .el-checkbox__inner {
		border-color: #006e4b;
	}

	.el-checkbox__inner:hover {
		border-color: #006e4b;
	}
</style>



// WEBPACK FOOTER //
// Yglz.vue?0ef562d2